import React, { InputHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';

// theme
import { spacing, fontSizes, theme } from '../../utils';

//icons
import { SearchIcon } from '../Icon';
import { Input } from '../Input';

const SearchWrapper = styled.span`
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

const IconWrapper = styled.span`
  position: absolute;
  top: 16px;
  left: 10px;
  z-index: 2;
`;

type SearchBarProps = {
  label?: string;
  autoFocus?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange?: any;
};

export const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(
  ({ isLoading, placeholder, onChange }, ref) => {
    return (
      <SearchWrapper>
        <IconWrapper>
          <SearchIcon color="white" size="small" />
        </IconWrapper>
        <Input
          ref={ref}
          type="text"
          withIcon={true}
          isLoading={isLoading}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
      </SearchWrapper>
    );
  },
);

export default SearchBar;
